module.exports = __webpack_public_path__ + "img/bt-flower-001.688c26f.webp";